import type { AxiosInstance } from "axios";

import { toast } from "sonner";

import type { UserProfile } from "@/types/user";

import { useMutation, useQuery } from "@tanstack/react-query";

import { usePrivateAxios } from "./use-private-axios";

async function fetchUsers(privateAxios: AxiosInstance) {
	const { data } = await privateAxios.get("/auth/get_users");
	return data;
}

export function useUsers() {
	const privateAxios = usePrivateAxios();
	return useQuery({
		queryKey: ["users"],
		queryFn: () => fetchUsers(privateAxios)
	});
}

export function useUpdateUserProfile() {
	const privateAxios = usePrivateAxios();
	return useMutation({
		mutationKey: ["user", "update-profile"],
		mutationFn: async (user: Partial<UserProfile>): Promise<UserProfile> => {
			return (await privateAxios.patch("/auth/update_profile", user)).data.data;
		},
		onSuccess: () => {
			toast.success("Profile updated successfully");
		},
		onError: () => toast.error("Something went wrong")
	});
}
export function useUserProfile() {
	const privateAxios = usePrivateAxios();
	return useQuery({
		queryKey: ["user-profile"],
		queryFn: async (): Promise<UserProfile> => {
			return (await privateAxios.get("/auth/user_profile")).data.data;
		}

	});
}
